import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Account } from "../models/account";
import { ObjectSchema, object, string } from "yup";

export type ContactUsFormValues = {
  name: string;
  phone: string;
  email: string;
  message: string;
};

const contactUsValidationSchema: ObjectSchema<ContactUsFormValues> = object({
    name: string().required("Name field is required"),
    phone: string()
      .required("Phone field is required")
      .matches(
        /^\+?(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\\-]?[0-9]{3}[\s\\-]?[0-9]{4}$/,
        "Phone number is invalid"
      ),
    email: string()
      .email("Please enter a valid email")
      .required("Email field is required"),
    message: string().required("Message field is required"),
  })
  .required();

export function useContactUsForm(account?: Account) {
  return useForm<ContactUsFormValues>({
    resolver: yupResolver(contactUsValidationSchema),
    reValidateMode: "onChange",
    defaultValues: {
      name: account ? `${account.firstName} ${account.lastName}` : "",
      phone: account?.phone,
      email: account?.email,
    },
  });
}
